import { render, staticRenderFns } from "./icon-map-marker-orange.vue?vue&type=template&id=5febe9b9&"
import script from "./icon-map-marker-orange.vue?vue&type=script&lang=js&"
export * from "./icon-map-marker-orange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\MidwestBeltone.Iframes.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5febe9b9')) {
      api.createRecord('5febe9b9', component.options)
    } else {
      api.reload('5febe9b9', component.options)
    }
    module.hot.accept("./icon-map-marker-orange.vue?vue&type=template&id=5febe9b9&", function () {
      api.rerender('5febe9b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/icons/icon-map-marker-orange.vue"
export default component.exports